import {TShow} from '../../../../hooks/useShow';
import {TMemberSubscription} from '../memberTicket.type';
import sanitizeHtml from '../../../../library/sanitizeHtml';
import SheetShell from '../../components/SheetShell/SheetShell';
import {useSubscriptionList} from '../useSubscriptionList';
import MemberSeriesInfoBar from './MemberSeriesInfoBar';
import MemberSeriesEvents from './MemberSeriesEvents';
import MemberListLoader from '../memberListLoader/MemberListLoader';
import MemberListError from '../memberListError/MemberListError';
import * as css from './MemberInfoSheet.css';

/* The sheet is text only — the media the producer embedded in the description stays out */
const MEDIA_TAGS = ['img', 'picture', 'video', 'iframe'];

interface MemberInfoSheetProps {
    show: TShow;
    subscription: TMemberSubscription;
}

/* "Subscription details" — the only way into the extended information about the series:
   its type, the producer's text, and the events it includes */
function MemberInfoSheet({show, subscription}: MemberInfoSheetProps) {
    const {planType, totalCredits, description} = subscription;
    // The same event list as "tickets to redeem" — fetched once and shared by both sheets
    const {items: events, isLoading, hasError, retry, onScroll} = useSubscriptionList('events', subscription.qid, show.isOpen);

    return (
        <SheetShell show={show} title={subscription.title} data-cy="member-info-sheet">
            {/* The body is the scrolling element here, so it is what pages the event list in */}
            <css.body onScroll={onScroll}>
                <MemberSeriesInfoBar planType={planType} totalCredits={totalCredits} />
                {description && <css.description dangerouslySetInnerHTML={sanitizeHtml(description, {FORBID_TAGS: MEDIA_TAGS})} data-cy="member-series-description" />}
                {!!events?.length && <MemberSeriesEvents events={events} />}
                {isLoading && <MemberListLoader data-cy="member-info-loader" />}
                {/* Never `initial`: the sheet has its own content above, the failed list is only a part of it */}
                {hasError && <MemberListError onRetry={retry} data-cy="member-info-error" />}
            </css.body>
        </SheetShell>
    );
}

export default MemberInfoSheet;
